export default __webpack_public_path__ + "static/media/ar.9f789bcd.svg";